import {
  apiGetRecurringRules,
  apiCreateRecurringRule,
  apiUpdateRecurringRule,
  apiDeleteRecurringRule,
  apiGetAutomatedOrders,
} from 'api';
import { recurringRulesTypes } from '../types';

// GET_RECURRING_RULES
export const getRecurringRules = (companyId, cb) => {
  return {
    isAsyncCall: true,
    baseType: recurringRulesTypes.GET_RECURRING_RULES,
    payload: {},
    asyncCall: () => {
      return apiGetRecurringRules(companyId);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

// CREATE_RECURRING_RULE
export const createRecurringRule = (companyId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: recurringRulesTypes.CREATE_RECURRING_RULE,
    payload: {},
    asyncCall: () => {
      return apiCreateRecurringRule(companyId, data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

// UPDATE_RECURRING_RULE
export const updateRecurringRule = (companyId, ruleId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: recurringRulesTypes.UPDATE_RECURRING_RULE,
    payload: {},
    asyncCall: () => {
      return apiUpdateRecurringRule(companyId, ruleId, data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

// DELETE_RECURRING_RULE
export const deleteRecurringRule = (companyId, ruleId, cb) => {
  return {
    isAsyncCall: true,
    baseType: recurringRulesTypes.DELETE_RECURRING_RULE,
    payload: {},
    asyncCall: () => {
      return apiDeleteRecurringRule(companyId, ruleId);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

// GET_AUTOMATED_ORDERS
export const getAutomatedOrders = (companyId, params, cb) => {
  return {
    isAsyncCall: true,
    baseType: recurringRulesTypes.GET_AUTOMATED_ORDERS,
    payload: {},
    asyncCall: () => {
      return apiGetAutomatedOrders(companyId, params);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
